export default class Faq {
  constructor(item, lang) {
    this._setId(item);
    this._setDescription(item, lang);
    this._setTitle(item, lang);
  }

  /**
   * set id
   * @param {id} param0
   */
  _setId({ id }) {
    this.id = id;
  }

  /**
   * set title
   * @param {faq} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "title_" + lang;
    this.title = item[key];
  }

  /**
   * set description
   * @param {faq} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }
}
